import { LangCode } from "../models";

export interface TagInput {
  id?: number;
  translations?: TagInfoInput[];
     slug?: string;
    icon_image_url?: string;
    gradient_color_1?: string;
    gradient_color_2?: string;
    show_in_home?: boolean;
    show_banner_image?: boolean;
    use_gradient_colors?: boolean;
    // tag_translations: [];
//  tag_translations?: {
//     language: string;
//     name: string;
//   }[]
  }

interface TagInfoInput {
  lang_code: LangCode;
  tag_name: string;
}
// export interface CreateTagInput {
//   slug: string;
//   icon_image_url: any;
//   gradient_color_1: string;
//   gradient_color_2: string;
//   show_in_home: boolean;
//   show_banner_image: boolean;
//   use_gradient_colors: boolean;
//   tag_translations: {
//     language: string;
//     name: string;
//   }[];
// }
